import React, { createContext, useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { langFromPath, equivalentPath } from '../config/landings';
import { translations } from '../i18n/translations';

const LanguageContext = createContext();

export const META = {
  es: {
    title: 'Clases de Español Online 1 a 1 | Profesora DELE',
    description: 'Clases de español online particulares y personalizadas para adultos. Mejora conversación, gramática y fluidez con Cecilia Mateo, examinadora DELE. Clase de prueba gratis.',
    lang: 'es'
  },
  en: {
    title: '1-to-1 Online Spanish Lessons | DELE Examiner Teacher',
    description: 'Private, personalised online Spanish lessons for adults. Improve conversation, grammar and fluency with Cecilia Mateo, DELE examiner. Free trial lesson.',
    lang: 'en'
  },
  de: {
    title: 'Spanisch Einzelunterricht Online | DELE-Prüferin',
    description: 'Privater, individueller Spanischunterricht online für Erwachsene. Verbessere Konversation, Grammatik und Flüssigkeit mit Cecilia Mateo, DELE-Prüferin. Kostenlose Probestunde.',
    lang: 'de'
  }
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  // El idioma depende de la URL: / (es), /de/... (de), /en/... (en).
  const language = langFromPath(location.pathname);

  const t = translations[language];

  useEffect(() => {
    // El <title> y la meta description los gestiona el componente Seo de cada
    // página: aquí solo fijamos el idioma del documento (antes este efecto
    // sobrescribía el título de cada página con el genérico de la home).
    const meta = META[language] || META.es;
    document.documentElement.lang = meta.lang;
  }, [language]);

  // El selector lleva a la página equivalente del otro idioma (o a su home).
  const changeLanguage = (lang) => {
    if (lang === language) return;
    navigate(equivalentPath(location.pathname, lang));
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};